import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(true);

  useEffect(() => {
    // Check for saved theme in localStorage
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      setIsDarkMode(savedTheme === 'dark');
    }
  }, []);

  useEffect(() => {
    // Update localStorage when theme changes
    localStorage.setItem('theme', isDarkMode ? 'dark' : 'light');
    
    // Update html element class for global theme
    const htmlElement = document.documentElement;
    if (isDarkMode) {
      htmlElement.classList.remove('light');
    } else {
      htmlElement.classList.add('light');
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };

  const theme = {
    isDarkMode,
    toggleTheme,
    colors: {
      // Dark mode colors
      dark: {
        bodyColor: "#000000", // Keeping pure black as requested
        lightText: "#a0a0a0", // Slightly darker text for better contrast
        designColor: "#ff014f",
        bgGradient: "linear-gradient(145deg, #0a0a0a, #121212)",
        shadowOne: "10px 10px 19px rgba(0, 0, 0, 0.7), -10px -10px 19px rgba(20, 20, 20, 0.3)", // Deeper shadows
      },
      // Light mode colors (now also dark)
      light: {
        bodyColor: "#0a0a0a", // Much darker background
        lightText: "#a0a0a0",
        designColor: "#dc2626",
        bgGradient: "linear-gradient(145deg, #0a0a0a, #121212)",
        shadowOne: "10px 10px 19px rgba(0, 0, 0, 0.5), -10px -10px 19px rgba(20, 20, 20, 0.2)", // Deeper shadows
      }
    }
  };

  return (
    <ThemeContext.Provider value={theme}>
      {children}
    </ThemeContext.Provider>
  );
};